module.exports = __webpack_public_path__ + "static/media/Clear_Icon.65ebf632.svg";